import { queryOptions, useQuery } from '@tanstack/react-query';

import { pushApi } from '../api/push-api';

import { pushKeys } from './push-keys';

export function pushSettingsQueryOptions() {
  return queryOptions({ queryKey: pushKeys.settings(), queryFn: pushApi.settings });
}

/** The server's VAPID key, delivery mode and the member's devices. */
export function usePushSettings(enabled = true) {
  return useQuery({ ...pushSettingsQueryOptions(), enabled });
}
